import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextLanguagesPipe } from './text-languages/text-languages.pipe';
import { ImageToUrlPipe } from './imageToUrl/image-to-url.pipe';
import { CurrenciePipe } from './currencie/currencie.pipe';
import { DateTimeToTimePipe } from './date-time-to-time/date-time-to-time.pipe';
import { ToMoneyPipe } from './money-pipes/to-money.pipe';
import { ToHealthCreditsPipe } from './money-pipes/to-health-credits.pipe';
import { HealthcarepackagesTostringPipe } from './healthcarepackagestostring/healthcarepackages-tostring.pipe';
import { TruncatePipe } from './truncate/truncate.pipe';
import { GetMapPhotoUrlPipe } from './get-map-photo-url/get-map-photo-url.pipe';
import { RoundPipe } from './round-pipe.pipe';
import { ImageToUrlPipeAsync } from './imageToUrl/image-to-url-async.pipe';
@NgModule({
  declarations: [
    TextLanguagesPipe,
    ImageToUrlPipe,
    CurrenciePipe,
    DateTimeToTimePipe,
    ToMoneyPipe,
    ToHealthCreditsPipe,
    HealthcarepackagesTostringPipe,
    TruncatePipe,
    GetMapPhotoUrlPipe,
    RoundPipe,
    ImageToUrlPipeAsync,
  ],
  imports: [CommonModule],
  exports: [
    TextLanguagesPipe,
    ImageToUrlPipe,
    CurrenciePipe,
    DateTimeToTimePipe,
    HealthcarepackagesTostringPipe,
    TruncatePipe,
    GetMapPhotoUrlPipe,
    RoundPipe,
    ImageToUrlPipeAsync,
  ],
})
export class PipesModule {}
